import axios from "axios";
import { BASE_URL_CORAL_TEAM_VERSION } from "./constants";

const AUTH_PREFIX = "auth";

export const loginAdminWithEmail = (email, password) => {
  const payload = {
    email: (email || "").trim(),
    password: password || "",
  };

  return axios.post(
    `${BASE_URL_CORAL_TEAM_VERSION}${AUTH_PREFIX}/login-email`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

export const loginStoreWithEmailFallback = (email, password) => {
  const payload = {
    email: (email || "").trim(),
    password: password || "",
  };

  return axios.post(
    `${BASE_URL_CORAL_TEAM_VERSION}${AUTH_PREFIX}/login-email`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};
